<template>
  <div>
    <!-- <canvas id="canvas" width="120" height="70"></canvas> -->
    <b-button variant="outline-light" class="p-0" @click="isVisible = true">
      <img
        id="mainImg"
        :src="finalImage"
        class="rounded space-preview"
        @error="
          (e) => (e.target.src = require('@/assets/images/img-placeholder.png'))
        "
      />
    </b-button>
    <vue-easy-lightbox
      :visible="isVisible"
      :imgs="imgsRef"
      @hide="isVisible = false"
    ></vue-easy-lightbox>
  </div>
</template>

<script>
export default {
  props: ["imgSrc"],
  data() {
    return {
      finalImage: "",
      isVisible: false,
      imgsRef: [],
    };
  },
  async mounted() {
    
    var originImg = new Image();
    originImg.setAttribute("crossorigin", "anonymous");
    originImg.onload = () => {
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var cw = originImg.naturalWidth;
      var ch = originImg.naturalHeight;
      
      const wRatio = 65;
      const hRatio = 44;

      // var coorX1 = this.imgSrc.coordinate_x1 / wRatio * cw;
      // var coorX2 = this.imgSrc.coordinate_x2 / wRatio * cw;
      // var coorY1 = this.imgSrc.coordinate_y1 / hRatio * ch;
      // var coorY2 = this.imgSrc.coordinate_y2 / hRatio * ch;

      var coorX1 = this.imgSrc.coordinate_x1 / wRatio * cw;
      var coorX2 = this.imgSrc.coordinate_x2 / wRatio * cw;
      var coorY1 = this.imgSrc.coordinate_y1 / hRatio * ch;
      var coorY2 = this.imgSrc.coordinate_y2 / hRatio * ch;


      console.log('IMAGE DATA');
      console.log(this.imgSrc);
      console.log('CW:',cw);
      console.log('CH:',ch);
      console.log("X1",coorX1);
      console.log("X2",coorX2);
      console.log("Y1",coorY1);
      console.log("Y2",coorY2);

      var img = new Image();
      img.setAttribute("crossorigin", "anonymous");
      img.onload = () => {
        canvas.width = cw;
        canvas.height = ch;

        // draw the image on the canvas
        ctx.drawImage(img, 0, 0, cw, ch);

        // darken the image with a 50% black fill
        ctx.save();
        ctx.globalAlpha = 0.5;
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, cw, ch);
        ctx.restore();

        // ctx.clip() the area to highlight and redraw the whole image (the image will draw only in the clipping region)
        ctx.save();
        ctx.beginPath();
        ctx.strokeStyle = "#F84B04";
        ctx.lineWidth = 30;
        ctx.setLineDash([5, 3]);
        ctx.moveTo(0, 50);
        ctx.lineTo(300, 50);
        ctx.strokeRect(coorX1, coorY1, coorX2 - coorX1, coorY2 - coorY1);
        ctx.clearRect(coorX1, coorY1, coorX2 - coorX1, coorY2 - coorY1);
        ctx.rect(coorX1, coorY1, coorX2 - coorX1, coorY2 - coorY1);
        ctx.clip();
        ctx.drawImage(img, 0, 0, cw, ch);
        ctx.restore();

        ctx.save();
        ctx.beginPath();
        ctx.restore();

        this.finalImage = canvas.toDataURL();
        this.imgsRef[0] = canvas.toDataURL();
      };
      img.src = this.imgSrc.url;
    };
    originImg.src = this.imgSrc.url;
  },
};
</script>

<style scoped>
.space-preview {
  width: 112px;
  height: 112px;
  object-fit: cover;
}
</style>
